<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent: 00em;">I would like to thank my sister, Margery, who proved most encouraging in the development of my story. In this regard she carefully read and considered one of my initial constructions.</p><br/>
<p style="text-indent: 00em;">In recognition of my brother, Paddy McEvoy, who introduced me to the adventures of reading at Donnybrook, Dublin, public lending library.</p><br/>
<p style="text-indent: 00em;">In appreciation of my friend and wife, Sally, for her generous support towards the production of my story.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?e640a344